"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ColorGenerator = (element) => {
    switch (element) {
        case 'Red':
            return 0;
        case 'Green':
            return 1;
        case 'Blue':
            return 2;
        case 'Cyan':
            return 3;
        case 'Magenta':
            return 4;
        case 'Yellow':
            return 5;
        case 'White':
            return 6;
        case 'Black':
            return 7;
        default:
            return 7;
    }
};
exports.default = ColorGenerator;
